import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function CallRecord() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="summary">고객과의 통화내용은 이실장이 메신저처럼 기록해줘요</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<ol className="list_order"><li><h4 className="order_num">Step 1</h4><p className="order_desc">고객별로 과거부터 현재까지 모든 상담 내역을 확인할 수 있어요</p><Image className="img_guide" src="/image/mobile/popup/call01_01.png" alt={"\uACE0\uAC1D\uBCC4\uB85C \uACFC\uAC70\uBD80\uD130 \uD604\uC7AC\uAE4C\uC9C0 \uBAA8\uB4E0 \uC0C1\uB2F4 \uB0B4\uC5ED\uC744 \uD655\uC778\uD560 \uC218 \uC788\uC5B4\uC694"} width={100} height={100} /></li><li><h4 className="order_num">Step 2</h4><p className="order_desc">확인하고 싶은 상담내역만 누르면 통화 내용은 물론 녹음파일도 확인이 가능해요</p><Image className="img_guide" src="/image/mobile/popup/call01_02.png" alt={"\uCDA9\uC804\uAE08\uC774 \uC801\uC6A9\uB418\uC5C8\uC5B4\uC694."} width={100} height={100} /></li></ol></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}